export class pasmoUtils {
  static validatePasmoIdi(idi: string) {
    return !!idi.match(
      '^PB[0-9|A-F]{4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])(0000[0-9]{1}|000[0-9]{2}|00[0-9]{3}|0[0-9]{4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$'
    );
  }
}
